import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {authorSelector} from "../../ducks/product";
import {isAdminSelector} from "../../ducks/is-admin";
import withErrorBoundary from "../../../../decorators/withErrorBoundary";

import styles from "./author.module.scss";

function Author(props) {
  const {
    isAdmin,
    author: {name, storePath, inventoryPath}
  } = props;
  return (
    <div className={styles.root}>
      <span className={styles.label}>Дизайнер:</span>
      <a href={storePath} className={styles.value}>
        {name}
      </a>
      {isAdmin && (
        <a href={inventoryPath} className={styles.inventory}>
          (Инвентарь)
        </a>
      )}
    </div>
  );
}

Author.propTypes = {
  author: PropTypes.shape({
    name: PropTypes.string,
    storePath: PropTypes.string,
    inventoryPath: PropTypes.string
  }),
  isAdmin: PropTypes.bool
};

export default connect((state) => ({
  author: authorSelector(state),
  isAdmin: isAdminSelector(state)
}))(withErrorBoundary(Author));
